var render = function render(){var _vm=this,_c=_vm._self._c;return _c('supportLayout',[_c('div',{staticClass:"p-changelog full_page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"coming_soon"},[_c('h3',[_vm._v("In Development")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }